module.exports = __webpack_public_path__ + "static/media/credit.2b6ba71d.png";